import React from 'react';
import { Spacer, Text } from '@ontruck/orc';
import { OrderLink } from './idLink';

const soReturnCreatedRenderer = ({ changes: { return_for_id }, ...props }) => {
  return (
    <Spacer {...props}>
      {!!return_for_id && (
        <Text color="grey800" display="block">
          <OrderLink id={return_for_id} />
          is returned
        </Text>
      )}
    </Spacer>
  );
};

export default soReturnCreatedRenderer;
